// assets/js/ps-modal.js
(function () {
	"use strict";

	const modal = document.getElementById("ps-modal");
	if (!modal) return;

	const titleEl = modal.querySelector("#ps-modal-title");
	const contentEl = modal.querySelector("#ps-modal-content");
	const backdrop = modal.querySelector(".ps-modal__backdrop");
	const closeButtons = modal.querySelectorAll("[data-modal-close]");

	function openModal() {
		modal.classList.add("is-open");
		modal.setAttribute("aria-hidden", "false");
		document.body.style.overflow = "hidden";
	}

	function closeModal() {
		modal.classList.remove("is-open");
		modal.setAttribute("aria-hidden", "true");
		document.body.style.overflow = "";
	}

	function fetchPage(pageId) {
		const body = new URLSearchParams();
		body.set("action", "ps_get_page_content");
		// body.set("nonce", psModal.nonce);
		body.set("page_id", pageId);

		return fetch(sthmParams.ajaxurl, {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body,
			credentials: "same-origin",
		}).then((res) => res.json());
	}

	// Click handler for any .ps-modal-open button.
	document.addEventListener("click", (e) => {
		const btn = e.target.closest(".ps-modal-open");
		if (!btn) return;

		const pageId = btn.getAttribute("data-id");
		if (!pageId) return;

		// Optional: show loading state.
		titleEl.textContent = "Loading…";
		contentEl.innerHTML = "";

		fetchPage(pageId)
			.then((json) => {
				if (!json?.success) {
					titleEl.textContent = "Error";
					contentEl.innerHTML = `<p>${
						json?.data?.message || "Failed to load content."
					}</p>`;
					openModal();
					return;
				}

				const { title, content } = json.data;
				titleEl.textContent = title || "";
				contentEl.innerHTML = content || "";
				openModal();
			})
			.catch(() => {
				titleEl.textContent = "Error";
				contentEl.innerHTML = "<p>Network error.</p>";
				openModal();
			});
	});

	// Close on overlay click / X buttons.
	[backdrop, ...closeButtons].forEach((el) =>
		el.addEventListener("click", closeModal)
	);

	// Close on ESC.
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && modal.classList.contains("is-open")) {
			closeModal();
		}
	});
})();
